import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import useListDetailActions from 'Components/UI/ListDetailView/useListDetailActions';
import { useSelectionContextState } from 'Components/UI/ListDetailView/SelectionContext';
import { Link } from '@material-ui/core';
import fr from 'facet-rest';
import ConfirmationDialog from 'Components/UI/ConfirmationDialog';
import HeaderBar from 'Components/ComponentLibrary/Molecules/HeaderBar';
import { FDSecondaryActionIconButton } from '@facet-wealth/design';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';

const styles = (theme) => ({
  root: {},
  primaryDialogContent: {
    minWidth: theme.dimensions.sm,
  },
  saveLink: {
    paddingRight: theme.spacing(1),
  },
});

const Header = ({
  classes,
}) => {
  const {
    unselectResource,
    deleteResource,
  } = useListDetailActions();
  const { selectedResource } = useSelectionContextState();
  const [confirmDelete, setShowDelete] = React.useState(false);

  const rightAction = (
    <div>
      <Link
        href={selectedResource.relationship(fr.relationships.download.name).link('related').url()}
        download={selectedResource.attr('name')}
        className={classes.saveLink}
        target="_blank"
      >
        <SaveIcon />
      </Link>
      <IconButton
        edge="start"
        aria-label="Go back to household"
        title="Delete File"
        color="red"
        icon={DeleteIcon}
        onClick={() => setShowDelete(true)}
      />
      {confirmDelete && (
        <ConfirmationDialog
          classes={{ primaryDialogContent: classes.primaryDialogContent }}
          onConfirm={async () => {
            try {
              await deleteResource(selectedResource);
            } catch (e) {
              const msg = e.details?.err?.errors ? e.details?.err?.errors : 'Failed to delete file';
              displayErrorMessage(e, msg);
            }
            setShowDelete(false);
          }}
          onCancel={() => {
            setShowDelete(false);
          }}
          title={`Delete ${selectedResource.attr('name')}?`}
        />
      )}
    </div>
  );

  return (
    <HeaderBar
      title={'Previewing File'}
      left={(
        <FDSecondaryActionIconButton
          icon="chevronLeft"
          label="Back"
          onClick={() => unselectResource()}
        />
      )}
      right={rightAction}
    />
  );
};

Header.defaultProps = {};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
